import APIS from '../../constant/EndPoint';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import Button from '../Reusable/Button';
import ImportPreviewDataTable from './ImportPreviewDataTable';
import NACell from '../Reusable/DataTable/NACell';
import { useEffect } from 'react';
import ExcelUpload from '../Reusable/ExcelUpload';
import { uploadConsignmentExcelFileValidationForm } from '../../utils/validationSchemas';
//@ts-ignore
import { tw } from '@careinfo/tailwind';

const OrderBulkUpload = (props: any) => {
  const {
    handleFileUpload,
    inValidOrders,
    validOrders,
    openPreviewData,
    setOpenPreviewData,
    handleCommitValidOrders,
    isUploading,
    isFileUploading,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
    watch,
  } = useForm<any>({
    resolver: yupResolver(uploadConsignmentExcelFileValidationForm),
  });

  const columns: any = [
    {
      header: 'S.N',
      accessorKey: 'serial_number',
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: 'Pickup Branch',
      accessorKey: 'pickup_branch',
      cell: NACell,
    },
    {
      header: 'Destination Branch',
      accessorKey: 'destination',
      cell: NACell,
    },
    {
      header: 'Customer Name',
      accessorKey: 'receiver_name',
      cell: NACell,
    },
    {
      header: 'Customer Address',
      accessorKey: 'receiver_address',
      cell: NACell,
    },
    {
      header: 'Customer Primary Contact',
      accessorKey: 'receiver_primary_contact',
      cell: NACell,
    },
    {
      header: 'Weight',
      accessorKey: 'total_weight',
      cell: NACell,
    },
    {
      header: 'Piece',
      accessorKey: 'total_pieces',
      cell: NACell,
    },
    {
      header: 'Service Type',
      accessorKey: 'service_type',
      cell: NACell,
    },
    {
      header: 'Payment Method',
      accessorKey: 'payment_method',
      cell: NACell,
    },
  ];

  useEffect(() => {
    setOpenPreviewData(false);
  }, [watch('file'), watch('merchant')]);

  const totals = validOrders
    ? validOrders.children.reduce(
        (acc, item) => {
          acc.totalPieces += item.piece || 0;
          acc.totalWeight += item.weight || 0;
          return acc;
        },
        { totalPieces: 0, totalWeight: 0 }
      )
    : {};

  const result = [
    {
      ...validOrders,
      total_pieces: totals.totalPieces,
      total_weight: totals.totalWeight,
    },
  ];

  return (
    <>
      <form
        onSubmit={handleSubmit((data: any) => handleFileUpload(data, setError))}
        autoComplete='off'
      >
        <ExcelUpload
          register={register('file')}
          errors={errors}
          handleOnChange={handleFileUpload}
          url={APIS.ORDER}
          fileName={'order-sample-data'}
          watch={watch}
          setError={setError}
        />
        <div className={tw`flex justify-end w-full`}>
          <div className={tw`w-[100px] mr-4`}>
            <Button label={'Upload'} isLoading={isFileUploading} />
          </div>
        </div>
      </form>
      {openPreviewData && (
        <>
          <ImportPreviewDataTable
            title='Order Preview'
            data={result}
            columns={columns}
            isSubmit={true}
            handleSubmit={handleCommitValidOrders}
            isUploading={isUploading}
          />
        </>
      )}
    </>
  );
};

export default OrderBulkUpload;
